import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-e-con3',
  templateUrl: './e-con3.component.html',
  styleUrls: ['./e-con3.component.css']
})
export class ECon3Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
